import JSEncrypt from 'jsencrypt';

class Base64 {
    protected BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';

    protected int2char(n) {
      return this.BI_RM.charAt(n);
    }

    protected b64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

    protected b64pad = '=';

    static convertBase64toHex(s): string {
      return new Base64().b64tohex(s);
    }

    public b64tohex(s): string {
      const { b64pad } = this;
      const { b64map } = this;

      let ret = '';
      let i;
      let k = 0; // b64 state, 0-3
      let slop = 0;
      for (i = 0; i < s.length; ++i) {
        if (s.charAt(i) == b64pad) {
          break;
        }
        const v = b64map.indexOf(s.charAt(i));
        if (v < 0) {
          continue;
        }
        if (k == 0) {
          ret += this.int2char(v >> 2);
          slop = v & 3;
          k = 1;
        } else if (k == 1) {
          ret += this.int2char((slop << 2) | (v >> 4));
          slop = v & 0xf;
          k = 2;
        } else if (k == 2) {
          ret += this.int2char(slop);
          ret += this.int2char(v >> 2);
          slop = v & 3;
          k = 3;
        } else {
          ret += this.int2char((slop << 2) | (v >> 4));
          ret += this.int2char(v & 0xf);
          k = 0;
        }
      }
      if (k == 1) {
        ret += this.int2char(slop << 2);
      }
      return ret;
    }
}

export function encryptPassword(password: string, modulus: string, exponent: string): string | boolean {
  let encrypted: string | boolean = false;

  try {
    const encrypt = new JSEncrypt({});
    encrypt.getKey().setPublic(modulus, exponent);
    encrypted = encrypt.encrypt(`${password}`);
    encrypted = (`${encrypted}`).length > 0 ? Base64.convertBase64toHex(encrypted) : false;
  } catch (e) {
    encrypted = false;
  }

  return encrypted;
}
